import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=4b9d4e84&scoped=true&lang=pug"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d4e84",
  null
  
)

export default component.exports